import { emailSchema } from "@mailhand/core/schemas";
import { z } from "zod";

const claimsSchema = z.object({ sub: emailSchema });

function decodeSegment(segment: string): unknown {
  const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
  const json = new TextDecoder().decode(Uint8Array.from(atob(base64), (char) => char.charCodeAt(0)));
  return JSON.parse(json);
}

/** The member's email from the session token's `sub` claim. The console only reads it; the API verifies it. */
export function sessionEmail(token: string): string | null {
  const payload = token.split(".")[1];
  if (payload === undefined) return null;
  const claims = claimsSchema.safeParse(decodeSegment(payload));
  return claims.success ? claims.data.sub : null;
}
